import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";

import Grid from "@mui/material/Grid";
import moment from "moment";
import {Collapse} from "@mui/material";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import { v4 as uuidv4 } from 'uuid';
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import {MuiDataGrid} from "../../../components/MuiDatagrid";
import Tooltip from "@mui/material/Tooltip";
import {Logout, onErrorAlert, onSuccessAlert} from "../../../actions";
import {COLUMN_WIDTH} from "../../../constants";
import {enUS, zhCN} from "@mui/x-data-grid/locales";
import {cargoOwnerAddressList} from "../../../actions/customer/customerAction";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import LocalStorage from "../../../utils/LocalStorage";
import {useDispatch, useSelector} from "react-redux";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";

const AddressesInformation = ({list = [],loading,info,addressData}) => {
    const [isOpen,setIsOpen] = useState(true)
    // const [rows,setRows] = useState([])
    const {t} = useTranslation()
    const [addressList,setAddressList] = useState([])
    const [total,setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [pageNum, setPageNum] = useState(1)
    const [height, setHeight] = useState(0)
    const languageSelect = useSelector(state => state?.common?.language)
    const fixedNavbar = useSelector(state => state?.common?.fixedNavbar)
    const nav = useNavigate()
    const dispatch = useDispatch()


    useEffect(()=>{

        if(!(addressData.rows && addressData.total)){
            setAddressList([])
            setTotal(0)
        } else {
            setAddressList(addressData.rows.map((item, index) => {
                return { ...item, id: uuidv4() };
            }))
            setTotal(addressData.total)
        }

    },[addressData])

    const saveFormData = () => {
        let formData = {}
        formData.ownerId = info.ocpOwnerId
        formData.pageNum = pageNum
        formData.pageSize = pageSize

        if (LocalStorage.getItem('username')) {
            formData.userName = LocalStorage.getItem('username')
        } else {
            return null
        }

        return formData
    }

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onSearchSuccess = (data) => {
        setAddressList( data.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }))

    }

    useEffect(() => {

        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        const axiosPost = async () => {

            await dispatch(cargoOwnerAddressList(formData, onSearchSuccess, onError))
        }
        checkPermission(PERMISSION_DICT.CustomerCargoInfo)&& info.ocpOwnerId && axiosPost().then()


    }, [pageSize, pageNum]);

    function handlePaginationChange(data) {
        setPageNum(() => data.page + 1)
        setPageSize(() => data.pageSize)
    }

    const columns = [
        {
            field: 'ownerId',
            headerName: t('ownerId'),
            width: COLUMN_WIDTH.ownerId,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )

        },
        {
            field: 'customerId',
            headerName: t('CustomerPage.Customer ID'),
            width: 100,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )

        },
        {
            field: 'customerName',
            headerName: t('CustomerPage.Customer Name'),
            width: 110,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )

        },

        {
            field: 'isDefault',
            align: 'center',
            headerName: t('CustomerPage.Is Default'),
            width: 70,
            headerAlign: "left",
            renderCell: (params) => (
                <div>{params.value === 'Y'?'Yes':'No'}</div>
            )
        },
        {
            field: 'address1',
            headerName: t('SignUpPage.Address 1'),
            width: 150,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'address2',
            headerName: t('AccountPage.Address 2'),
            width: 90,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "country",
            headerName: t('SignUpPage.Country'),
            width: 80,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },

        {
            field: "province",
            headerName: t('AccountPage.State/Province'),
            width: 80,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "city",
            headerName: t('AccountPage.City'),
            width: 90,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },

        {
            field: "zipcode",
            headerName: t('AccountPage.Postal Code'),
            width: 80,
            align: "center",
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "contact",
            headerName: t("WarehousePage.Contact"),
            width: 80,
            align: "center",
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "contactTitle",
            headerName: t("title"),
            width: 80,
            align: "center",
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "contactFax",
            headerName: t("CustomerPage.Contact Fax"),
            width: 70,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: "contactEmail",
            headerName: t("Email"),
            width: 110,
            headerAlign: "left",
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },




    ]

    const handleCellDoubleClick = (params) => {
        const textToCopy = params?.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    return(<React.Fragment>
            <Fade in = {true}>
                <Card sx={{minWidth: 350}}>
                    <MDBox
                        mx={1}
                        mt={-3}
                        py={1}
                        px={2}
                        variant="gradient"
                        bgColor="light"
                        borderRadius="lg"
                        coloredShadow="light"
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}

                    >

                            <MDTypography variant="h6">
                                {t('CustomerPage.Addresses Information')}
                            </MDTypography>
                        <IconButton color={'white'}  disabled={loading}  size={'small'} onClick={()=>setIsOpen(!isOpen)}>
                            {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                        </IconButton>

                    </MDBox>

                    <Collapse in={isOpen&& !loading} timeout={500}>
                        <MDBox pb={2} px={2} mt={2}>

                            <Grid sx={{width: '100%'}}>
                                <MuiDataGrid
                                    rowHeight={40}
                                    sx={{
                                        '& .MuiDataGrid-main': {
                                            overflow: "unset"
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            position: "sticky",
                                            top: height,
                                            zIndex: '1100'
                                        },
                                    }}
                                    localeText={languageSelect === 'zh' ? zhCN.components.MuiDataGrid.defaultProps.localeText : enUS.components.MuiDataGrid.defaultProps.localeText}
                                    disableRowSelectionOnClick
                                    disableColumnMenu={true}
                                    disableColumnFilter={true}
                                    disableColumnSorting={true}
                                    getRowId={(row) => row?.id}
                                    autoHeight
                                    rowCount={total}
                                    columns={columns}
                                    rows={addressList}
                                    pageSizeOptions={[5, 15, 30]}
                                    initialState={{
                                        pagination: {paginationModel: {page: 0, pageSize: 5}},
                                    }}
                                    paginationMode={"server"}
                                    onPaginationModelChange={
                                        handlePaginationChange
                                    }

                                />

                            </Grid>
                        </MDBox>
                    </Collapse>

                </Card>
            </Fade>


        </React.Fragment>
    )
}

export default AddressesInformation